import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Inbox, FileText, Images, MessageSquareQuote, Lock } from "lucide-react";
import { api, fmtDate, typeLabel } from "@/lib/api";
import { AdminTitle } from "./AdminLayout";
import { StatusPill } from "./Contacts";

const Kpi = ({ icon: Icon, label, value, hint, to, testid }) => (
  <Link to={to} className="admin-card p-5 hover:border-slate-300 transition-colors" data-testid={testid}>
    <div className="flex justify-between"><p className="text-xs text-slate-500">{label}</p><Icon size={17} className="text-sagedark" /></div>
    <p className="mt-3 text-3xl font-semibold" data-testid={`${testid}-value`}>{value}</p>
    {hint && <p className="text-xs text-slate-500 mt-1">{hint}</p>}
  </Link>
);

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="text-slate-500">Caricamento...</p>;
  return (
    <div data-testid="admin-dashboard">
      <AdminTitle title="Dashboard" subtitle="Panoramica dello studio." />
      <div className="grid sm:grid-cols-2 xl:grid-cols-5 gap-4">
        <Kpi icon={Inbox} label="Nuovi contatti" value={s.leads_new} hint={`${s.leads_total} richieste totali`} to="/admin/contatti" testid="kpi-leads" />
        <Kpi icon={FileText} label="Preventivi in bozza" value={s.quotes_draft} hint={`${s.quotes_sent} inviati`} to="/admin/preventivi" testid="kpi-quotes" />
        <Kpi icon={Images} label="Storie pubblicate" value={s.stories_published} hint={`${s.stories_draft} in bozza`} to="/admin/portfolio" testid="kpi-stories" />
        <Kpi icon={MessageSquareQuote} label="Recensioni da approvare" value={s.reviews_pending} hint={`${s.reviews_published} pubblicate`} to="/admin/recensioni" testid="kpi-reviews" />
        <Kpi icon={Lock} label="Gallerie clienti" value={s.client_galleries} to="/admin/area-clienti" testid="kpi-galleries" />
      </div>
      <div className="admin-card p-5 mt-4" data-testid="dashboard-recent-leads">
        <p className="text-sm font-semibold mb-3">Ultime richieste</p>
        {s.recent_leads.length === 0 && <p className="text-sm text-slate-500">Nessuna richiesta ricevuta finora.</p>}
        {s.recent_leads.map((l) => (
          <div key={l.id} className="py-2.5 border-t border-slate-100 flex flex-wrap gap-3 items-center justify-between text-sm">
            <span className="font-medium min-w-[160px]">{l.name}</span><span className="text-slate-500">{typeLabel(l.event_type)}{l.event_date && ` · ${fmtDate(l.event_date)}`}</span><StatusPill status={l.status} />
          </div>
        ))}
      </div>
    </div>
  );
}
